import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { AdminFormPage } from "@components/CatalogIndex/AdminFormPage";
import GovernanceForm from "../GovernanceForm/GovernanceForm";

const FORM_ID = "governance-form";

function Edit({
  project_id,
  account,
  permission,
  project,
  projectPhases,
  projectVariables,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [governance, setGovernance] = useState(
    location.state.governance || null
  );

  const canSave =
    permission !== "view" &&
    permission !== "create" &&
    project?.data?.attributes?.status === "building";

  return (
    <AdminFormPage
      title={`Edit ${governance.description || "Governance"}`}
      formId={canSave ? FORM_ID : undefined}
      onCancel={() =>
        navigate(`/projects/${project_id}/project_governances`, {
          state: null,
        })
      }
    >
      <GovernanceForm
        formId={FORM_ID}
        governanceProp={governance}
        project_id={project_id}
        account={account}
        permission={permission}
        project={project}
        projectPhases={projectPhases}
        projectVariables={projectVariables}
      />
    </AdminFormPage>
  );
}

export default Edit;
